import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ws-ace-tab-content',
    templateUrl: './tabContent.component.html',
    standalone: false
})
export class AceTabContentComponent {
    @Input() heading: string;
    @Input() loaded: boolean;
    @Input() set active (active: boolean) {
        this.tabActive = active;
        if (active) {
            this.tabChange.emit(this.tabActive);
        }
    };

    @Output() tabChange: EventEmitter<boolean> = new EventEmitter();

    tabActive: boolean = false;
}
